import { Link } from "react-router-dom";
import OrbieeLogo from "../images/brand/orbiee-logo-inverse.png";
import {
  Instagram,
  Facebook,
  Twitter,
  YouTube,
  LinkedIn,
  Email,
} from "@mui/icons-material";

const Footer = () => {
  const handleSubscribe = (e) => {
    e.preventDefault();
    // Handle newsletter subscription
  };

  const footerLinks = {
    shop: [
      { name: "Women", path: "/products?category=women" },
      { name: "Men", path: "/products?category=men" },
      { name: "Accessories", path: "/products?category=accessories" },
      { name: "New Arrivals", path: "/products?category=new-arrivals" },
      { name: "Sale", path: "/products?category=sale" },
    ],
    corporate: [
      { name: "About JK Tech", path: "/about" },
      { name: "Careers", path: "/careers" },
      { name: "Sustainability", path: "/sustainability" },
      { name: "Press", path: "/press" },
      { name: "Investor Relations", path: "/investor-relations" },
    ],
    help: [
      { name: "Customer Service", path: "/customer-service" },
      { name: "My Account", path: "/account" },
      { name: "Find a Store", path: "/stores" },
      { name: "Legal & Privacy", path: "/legal" },
      { name: "Contact", path: "/contact" },
    ],
  };

  const socialLinks = [
    { icon: Instagram, label: "Instagram", href: "#" },
    { icon: Facebook, label: "Facebook", href: "#" },
    { icon: Twitter, label: "Twitter", href: "#" },
    { icon: YouTube, label: "YouTube", href: "#" },
    { icon: LinkedIn, label: "LinkedIn", href: "#" },
  ];

  const columns = [
    { title: "Shop", links: footerLinks.shop },
    { title: "Corporate", links: footerLinks.corporate },
    { title: "Help", links: footerLinks.help },
  ];

  return (
    <footer className="ob-footer">
      <div className="ob-footer-inner">
        {/* ── Top: brand + link columns + newsletter ── */}
        <div className="ob-footer-grid">
          {/* Brand */}
          <div className="ob-footer-brand">
            <Link to="/" className="ob-footer-mark" aria-label="Orbiee home">
              <img
                src={OrbieeLogo}
                alt="Orbiee — Retail assistant"
                className="ob-footer-logo"
              />
            </Link>

            <p className="ob-footer-blurb">
              Say what you want and Orbiee finds it — searches, styles, tries
              things on and checks you out, in your own words.
            </p>

            <div className="ob-footer-social">
              {socialLinks.map((social) => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    aria-label={social.label}
                    className="ob-footer-sociallink"
                  >
                    <IconComponent sx={{ fontSize: 17 }} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Link columns */}
          {columns.map((col) => (
            <nav key={col.title} className="ob-footer-col" aria-label={col.title}>
              <h2 className="ob-footer-coltitle">{col.title}</h2>
              <ul>
                {col.links.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path} className="ob-footer-link">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          {/* Newsletter */}
          <div className="ob-footer-col ob-footer-news">
            <h2 className="ob-footer-coltitle">Newsletter</h2>
            <p className="ob-footer-blurb ob-footer-blurb-sm">
              Exclusive offers and first look at new arrivals.
            </p>
            <button
              type="button"
              onClick={handleSubscribe}
              className="ob-btn ob-btn-sm ob-footer-subscribe"
            >
              <Email sx={{ fontSize: 15 }} />
              Subscribe
            </button>
          </div>
        </div>

        {/* ── Bottom bar ── */}
        <div className="ob-footer-bottom">
          <span className="ob-footer-copy">
            © 2026 JK Tech. All rights reserved.
          </span>

          <div className="ob-footer-meta">
            <Link to="/legal" className="ob-footer-link ob-footer-link-sm">
              Privacy
            </Link>
            <span className="ob-footer-sep" aria-hidden="true" />
            <Link to="/legal" className="ob-footer-link ob-footer-link-sm">
              Terms
            </Link>
            <span className="ob-footer-sep" aria-hidden="true" />
            <span className="ob-footer-currency">USD $</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
